// Shapes the raw snort/suricata alerts into the rows shown in the Network
// Alerts table. Shared with the report export so the json matches the table.
// The backend sends either srcip/dstip/signature or src_ip/dst_ip/message.
export const getNetworkAlertFields = (snortSuricataAlerts) => {
  if (!snortSuricataAlerts || !Array.isArray(snortSuricataAlerts)) {
    return [];
  }

  return snortSuricataAlerts.map((data, i) => ({
    id: i,
    srcIp: data.srcip ? data.srcip + ":" + data.srcport : data.src_ip + ":" + data.src_port,
    destIp: data.dstip ? data.dstip + ":" + data.dstport : data.dst_ip + ":" + data.dst_port,
    signature: data.signature ? data.signature.replace("ET", "") : data.message.replace("503", ""),
    protocol: data.protocol,
    country_code: data.country_code || "-",
  }));
};
